import type { ContentStore } from '@riva-mono/common';
import { writable } from 'svelte/store';

export const createContentStore = (): ContentStore => {
	return writable({
		initialized: false,
		replies: {},
		completed: false
	});
};
